<template>
    <div class="relative justify-end items-center flex gap-4">
        <StepIndicator
            :current-step="currentStep"
            :total-steps="3"
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
        <div class="justify-start items-start gap-2 flex">
            <button
                class="btn-base btn-white"
                @click="$emit('prev')"
                id="hs-wallet-copy-card-details-back"
            >
                {{ currentStep === 1 ? 'Cancel' : 'Back' }}
            </button>
            <button
                class="btn-base btn-dark"
                @click="$emit('next')"
                id="hs-wallet-copy-card-details-next"
            >
                {{ currentStep < 3 ? 'Next' : 'Copy Details' }}
            </button>
        </div>
    </div>
</template>

<script setup>
import StepIndicator from '@/components/ui/step-indicator/step-indicator.vue';

defineProps({
    currentStep: { type: Number, required: true },
});

defineEmits(['next', 'prev']);
</script>
